import { Scroll } from 'component/Scroll'
import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { DefaultSelfie } from 'page/ProfileScreen/Selfies/DefaultSelfie'
import { opt } from 'store/opt'
import { store } from 'store/store'

const man1 = 'https://dresscode-prod-2.s3.eu-central-1.amazonaws.com/tryon/example-man-1-c6bc.jpg'
const man2 = 'https://dresscode-prod-2.s3.eu-central-1.amazonaws.com/tryon/example-man-2-4e81.jpg'
const man3 = 'https://dresscode-prod-2.s3.eu-central-1.amazonaws.com/tryon/example-man-3-57e5.jpg'
const man4 = 'https://dresscode-prod-2.s3.eu-central-1.amazonaws.com/tryon/example-man-4-5eca.jpg'
const man5 = 'https://dresscode-prod-2.s3.eu-central-1.amazonaws.com/tryon/example-man-5-d3a3.jpg'
const woman1 = 'https://dresscode-prod-2.s3.eu-central-1.amazonaws.com/tryon/example-woman-1-6d84.jpg'
const woman2 = 'https://dresscode-prod-2.s3.eu-central-1.amazonaws.com/tryon/example-woman-2-9d68.jpg'
const woman3 = 'https://dresscode-prod-2.s3.eu-central-1.amazonaws.com/tryon/example-woman-3-cedc.jpg'
const woman4 = 'https://dresscode-prod-2.s3.eu-central-1.amazonaws.com/tryon/example-woman-4-9ab1.jpg'
const woman5 = 'https://dresscode-prod-2.s3.eu-central-1.amazonaws.com/tryon/example-woman-5-42aa.jpg'

const MEN = [man1, man2, man3, man4, man5]
const WOMEN = [woman1, woman2, woman3, woman4, woman5]

function getImages(male: boolean): string[] {
  const def = male ? MEN : WOMEN
  const selfies = opt.options.selfies
  const custom = male ? selfies?.male : selfies?.female
  return custom ?? def
}

export const DefaultSelfies = observer(() => {
  const { gender } = store.profile
  const images = getImages(gender === 'male')

  return <Vertical gap={12}>
    <Typo size={14} secondary center balance>
      {i18n('YouCanUseDefaultSelfies')}
    </Typo>
    <Space wide center>
      <Scroll fit drag wheel shift blur>
        <Space gap={12}>
          {images.map((src, index) => (
            <DefaultSelfie key={index} src={src} />),
          )}
        </Space>
      </Scroll>
    </Space>
  </Vertical>
})
